import { Carxteam, Ingeprop, Opesnfac, Taskgraf, Aleteleg, Aledocxx } from "./Graphics";
import Criticid from "./Graphics/Criticid";
import Invsindo from "./Graphics/Invsindo";
import Opepanel from "./Graphics/Opepanel";
import Entregau from "./Graphics/Entregau";
import Doabfact from "./Graphics/Doabfact";


/**
 * Componente para seleccionar la grafica a pintar
 */
export function Graphsel({
  graphName,
  graphComponent,
  MODIDXXX,
  PROIDXXX,
  graphKeyName,
  filtersFieldsGraph
}) {

  const properties = {
    graphName,
    MODIDXXX,
    PROIDXXX,
    graphKeyName,
    filtersFieldsGraph,
  };

  const types = {
    Taskgraf: <Taskgraf {...properties} />,
    Carxteam: <Carxteam {...properties} />,
    Ingeprop: <Ingeprop {...properties} />,
    Aleteleg: <Aleteleg {...properties} />,
    Aledocxx: <Aledocxx {...properties} />,
    Opesnfac: <Opesnfac {...properties} />,
    Criticid: <Criticid {...properties} />,
    Invsindo: <Invsindo {...properties} />,
    Opepanel: <Opepanel {...properties} />,
    Entregau: <Entregau {...properties} />,
    Doabfact: <Doabfact {...properties} />,
  };


  return <>{types[graphComponent]}</>;
}
